export default {
  name: "NavMenu",

  data: {
    active: false
  },

  created() {
    window.sette.emitter.$on("NavMenu.toggle", this.toggle)
  },

  methods: {
    toggle() {
      this.active = !this.active;
    }
  }
};